import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';
import { random, sampleOne } from '@/utils';

import ButtonRainbow from '@/components/ButtonRainbow';
import Sparkles from '@/components/Sparkles';

import SparkleGlitterPhoto from './SparkleGlitterPhoto';

const getPerimeterPosition = (size) => {
  let style = {};
  style.zIndex = 3;

  const side = sampleOne(['top', 'left', 'right', 'bottom']);

  if (side === 'top') {
    style.top = 0;
    style.left = `${random(0, 100)}%`;
  } else if (side === 'left') {
    style.left = 0;
    style.top = `${random(0, 100)}%`;
  } else if (side === 'right') {
    style.left = '100%';
    style.top = `${random(0, 100)}%`;
  } else {
    style.top = '100%';
    style.left = `${random(0, 100)}%`;
  }

  return style;
};

const Demos = () => {
  return (
    <Wrapper>
      <Cell>
        <Title>Rainbow text</Title>
        <CellContents>
          <Sparkles
            colors={[
              'hsl(50deg, 100%, 65%)',
              'hsl(210deg, 100%, 65%)',
              'hsl(340deg, 100%, 60%)',
            ]}
          >
            Rainbow!
          </Sparkles>
        </CellContents>
      </Cell>
      <Cell>
        <Title>On an image</Title>
        <CellContents>
          <SparkleGlitterPhoto />
        </CellContents>
      </Cell>
      <Cell>
        <Title>Twinkle button</Title>
        <CellContents>
          <Sparkles
            generatePosition={getPerimeterPosition}
            isToggleable={false}
            minSize={20}
            maxSize={40}
            rate={600}
          >
            <GoButton>Go!</GoButton>
          </Sparkles>
        </CellContents>
      </Cell>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;

  @media ${BREAKPOINTS.smAndSmaller} {
    flex-direction: column;
  }
`;

const Cell = styled.div`
  flex: 1;
  padding-bottom: 16px;

  @media ${BREAKPOINTS.mdAndLarger} {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    padding-bottom: 0;
  }
`;

const CellContents = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-size: 1rem;
  font-weight: var(--font-weight-medium);
  background: var(--color-code-bg);
  border-radius: 6px;
  margin: 1px;
  margin-bottom: 16px;
  text-align: center;
`;

const GoButton = styled(ButtonRainbow)`
  width: 85px;
  height: 65px;
`;

export default Demos;
